/**
 * @file 路由
 * @author chenyuyang
 */
import React from 'react';
import {Switch, Route} from 'react-router-dom';
import {withRouter} from 'react-router';
import {connect} from 'react-redux';

import {fetchUserInfo} from './actions/attestAction';
import {fetchIpUserInfo} from './actions/ipAppealAction';

import Footer from './components/Footer/index';
import Attest from './pages/attest/index';
import AttestStep from './pages/attestStep';
import CompanyGuide from './pages/companyGuide';
// import AppealMajor from './pages/appeal/appeal';
import AppealMajor from './pages/appeal/appealMajor.tsx';
import MarkMajor from './pages/mark/mark';
import MarkErr from './pages/errorPage/markErr';
import NumErr from './pages/errorPage/numErr';
import Help from './pages/help';
import Partner from './pages/partner';
import FeedbackMajor from './pages/feedback/feedback';
import YellowPage from './pages/yellowPage';
import UserCenter from './pages/userCenter';
import InfoAttest from './pages/infoAttest';
import InfoAppeal from './pages/infoAppeal';
import LocationPage from './pages/locationPage/index';
import InfoMark from './pages/infoMark';
import Demo from './pages/demo';
import CallAuth from './pages/callAuth/index';

import Header from './components/Header/index';
import NewBusinessCard from './pages/businessCard/newCard';
import PzCard from './pages/businessCard/pzCard';

// new haoma
import Home from './pages/newHome/index';

// 外部人员使用-审核页面
import DataReviewList from './pages/dataReview/dataReviewList';
import DataReviewDetail from './pages/dataReview/dataReviewDetail';

import NormalLandPage from './pages/normalLandPage/index';

// 支持智能体-增加扫码拨号页面
import ScanCodePage from './pages/scanCode/index';

// ip-申诉页面：给ip阿拉丁卡片使用的申诉入口
import IpAppealPage from './pages/ipAppeal/index';
import IpAppealList from './pages/ipAppeal/list';
import IpAppealDetail from './pages/ipAppeal/detail';

import {clearLocalStorage} from './util';
import 'antd/dist/antd.css';

import './App.less';
export class App extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            conMinHeight: 0,
            hasLogin: false
        };
    }

    handleFetchUserInfo = (fetchAction) => {
        fetchAction().then(res => {
            const {code} = res || {};
            if (code === 200) {
                const username = window.localStorage.getItem('username');
                if (!username) {
                    window.localStorage.setItem('username', res.data.name);
                }
                this.setState({
                    hasLogin: true
                });
            } else {
                clearLocalStorage();
            }
        });
    };

    componentDidMount() {
        if (window['passRefreshTk']) {
            const {refreshTkInit} = window['passRefreshTk'];
            refreshTkInit && refreshTkInit({
                tpl: 'bmsec',
                // 存在风险回调，目前业务无需关注这块，可不写
                riskCallback: () => {
                    console.log('riskCallback执行了....');
                },
            });
        }
        // IP信息报错页面(ip_appeal)不根据老的user/info接口判断登录
        if (window.location.href.indexOf('/ip_appeal') !== -1) {
            this.handleFetchUserInfo(this.props.fetchIpUserInfo);
        } else {
            this.handleFetchUserInfo(this.props.fetchUserInfo);
        }
    }

    render() {
        const {userInfo} = this.props;
        const {hasLogin} = this.state;

        const loginUrl = ['/attest/pre', '/attest/step', '/appeal/step', '/user_center', '/mark'].some(item => {
        // let loginUrl = ['/attest/pre', '/attest/step', '/appeal/step', '/user_center'].some(item => {
            return window.location.href.indexOf(item) !== -1;
        });
        const hideHeaderUrl = ['/scan_code'].some(item => {
            return window.location.href.indexOf(item) !== -1;
        });
        const hideFooterUrl = ['/scan_code', 'ip_appeal'].some(item => {
            return window.location.href.indexOf(item) !== -1;
        });
        const hideHeaderMenu = ['/ip_appeal'].some(item => {
            return window.location.href.indexOf(item) !== -1;
        });
        const isIpPage = ['/ip_appeal'].some(item => {
            return window.location.href.indexOf(item) !== -1;
        });
        return (
            <div id="app">
                {!hideHeaderUrl && <Header
                    isHideMenu={hideHeaderMenu}
                    isIpPage={isIpPage}
                    userInfo={userInfo}
                    hasLogin={hasLogin}
                />}
                {!userInfo.code && loginUrl ? null : (
                    <div className={hideFooterUrl ? 'app-container no-footer' : 'app-container'}>
                        <Switch>
                            <Route exact path={'/'} component={Home} />
                            <Route exact path={'/mark_err'} component={MarkErr} />
                            <Route exact path={'/num_err'} component={NumErr} />
                            <Route exact path={'/home/:type?'} component={Home} />
                            <Route exact path={'/attest/:type?'} component={Attest} />
                            <Route exact path={'/attests/:type?'} component={Attest} />
                            {/* <Route exact path={'/attest/pre'} component={PreAttest} /> */}
                            <Route exact path={'/attest/step/:num/:id?/:type?'} component={AttestStep} />
                            <Route exact path={'/call_auth'} component={CallAuth} />
                            <Route exact path={'/companyGuide'} component={CompanyGuide} />
                            {/* <Route exact path={'/appeal'} component={Appeal} /> */}
                            <Route exact path={'/appeal'} component={AppealMajor} />
                            <Route exact path={'/occupy'} component={AppealMajor} />
                            {/* <Route exact path={'/mark/:key?/:form?'} component={Mark} /> */}
                            <Route exact path={'/mark/:key?'} component={MarkMajor} />
                            {/* <Route exact path={'/mark_msg/:key?'} component={MarkMsg} /> */}
                            <Route exact path={'/verify_msg/:key?'} component={AppealMajor} />
                            <Route exact path={'/help'} component={Help} />
                            <Route exact path={'/partner'} component={Partner} />
                            <Route exact path={'/feedback'} component={FeedbackMajor} />
                            {/* <Route exact path={'/upgrade'} component={Upgrade} /> */}
                            <Route exact path={'/appeal/step/:num/:phone?/:id?/:type?'} component={AppealMajor} />
                            <Route exact path={'/phoneSearch'} component={NormalLandPage} />
                            <Route exact path={'/yellow_page/:id?'} component={YellowPage} />
                            <Route exact path={'/user_center/:type'} component={UserCenter} />
                            <Route exact path={'/info_attest/:id?/:type?'} component={InfoAttest} />
                            <Route exact path={'/info_appeal/:id?/:type?'} component={InfoAppeal} />
                            <Route exact path={'/info_mark/:id?'} component={InfoMark} />
                            <Route exact path={'/business-card'} component={NewBusinessCard} />
                            <Route exact path={'/pz-card'} component={PzCard} />
                            <Route exact path={'/demo/:company?'} component={Demo} />
                            <Route exact path={'/location_page'} component={LocationPage} />
                            <Route exact path={'/data_review'} component={DataReviewList} />
                            <Route
                                exact
                                path={'/data_review/:pageType/:pageId/:cardType'}
                                component={DataReviewDetail}
                            />
                            <Route exact path={'/scan_code'} component={ScanCodePage}/>
                            <Route exact path={'/ip_appeal/list'} component={IpAppealList} />
                            <Route exact path={'/ip_appeal/detail/:id'} component={IpAppealDetail} />
                            <Route path={'/ip_appeal'} component={IpAppealPage}/>
                            <Route path="*" component={Home}/>
                        </Switch>
                    </div>
                )}
                {!hideFooterUrl && <Footer hasLogin={hasLogin} />}
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch: Function) {
    return {
        fetchUserInfo: () => fetchUserInfo(dispatch),
        fetchIpUserInfo: () => fetchIpUserInfo(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
